import {
    Backdrop,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    CircularProgress,
    Container,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    createTheme,
    Dialog, DialogTitle, DialogActions, DialogContent,
    TablePagination,
    Tooltip,
    Typography,
    CardMedia
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import Alert from 'src/components/Alert';
import moment from 'moment';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import { Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { confirmAlert } from 'react-confirm-alert';
import { DataGrid } from '@material-ui/data-grid';
import * as XLSX from 'xlsx';
import image from 'src/assets/images/konsep_2.jpg';

const materialTheme = createTheme({
    palette: {
        primary: {
            contrastText: '#FF9800',
            dark: '#424242',
            main: '#424242',
            light: '#424242'
        }
    }
});

const localeMap = {
    tr: trLocale
};

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    table: {
        minWidth: 650,
    },
    button: {
        margin: theme.spacing(1),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    title: {
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    media: {
        height: 210,
        padding: theme.spacing(6, 2)
    },
    customCardContent: {
        '&.MuiCardContent-root:last-child': {
            paddingBottom: '0.65rem'
        }
    }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


function MaterialEquivalentReport() {
    const classes = useStyles();
    const params = useParams();

    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [generalData, setGeneralData] = useState([]);
    const [kullanicilar, setKullanicilar] = useState([]);
    const [selectedKullanici, setSelectedKullanici] = useState([]);
    const [muadilModelEklePopUp, setMuadilModelEklePopUp] = useState(false);
    const [excelYukleSilPopUp, setExcelYukleSilPopUp] = useState(false);
    const [excelYukleSecimPopUp, setExcelYukleSecimPopUp] = useState(false);
    const [excelKaynakModelliYukleSilPopUp, setExcelKaynakModelliYukleSilPopUp] = useState(false);
    const [dataExcel, setDataExcel] = useState([]);
    const [hedefVeKaynaklidataExcel, setHedefVeKaynakliDataExcel] = useState([]);
    const [malzemeMuadilGelenFromlarData, setMalzemeMuadilGelenFromlarData] = useState([]);
    const [changedData, setChangedData] = useState([]);
    const [malzemeStokNoFrom, setMalzemeStokNoFrom] = useState([]);
    const [malzemeStokNoTo, setMalzemeStokNoTo] = useState([]);
    const [malzemeStokNoFromInput, setMalzemeStokNoFromInput] = useState([]);
    const [selectedMalzemeStokNoTo, setSelectedMalzemeStokNoTo] = useState([]);
    const [malzemeStokNoToAutoComplete, setMalzemeStokNoToAutoComplete] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(10);
    const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
        new Date().toString()
    );

    const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
        new Date().toString()
    );
    const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY')
    const formattedBitisDate = moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY')
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        getModelMuadilKullanicilar();
        getMuadilModelMalzemeStokNoTo();
    }, [])

    const getModelMuadilKullanicilar = () => {
        axios.get('/GetMuadilModelSuperKullanicilar').then((response) => {
            setKullanicilar(response.data);
        })
    }

    const getMuadilModelMalzemeStokNoTo = () => {
        axios.get('/GetMuadilModelMalzemeStokNoTo').then((response) => {
            setMalzemeStokNoToAutoComplete(response.data);
        })
    }

    function GeneralDataFiltreleAra() {
        if (selectedKullanici.length <= 0) {
            setresponseMessage('Lütfen önce kullanıcı seçimi yapınız!...')
            setUyariTip('error')
            setUyari(true)
            return
        }

        var kullanicilarList = [];
        selectedKullanici.map((i) => {
            kullanicilarList.push(i.USER_ID);
        })

        var malzemeStokNoToList = [];
        selectedMalzemeStokNoTo.map((i) => {
            malzemeStokNoToList.push(i.MALZEME_STOK_NO_TO);
        })

        const data = {
            BASLANGICTARIHI: formattedBaslangicDate,
            BITISTARIHI: formattedBitisDate,
            USER_ID: kullanicilarList.toString(),
            MALZEME_STOK_NO_FROM_INPUT: malzemeStokNoFromInput.length > 0 ? malzemeStokNoFromInput : '0',
            MALZEME_STOK_NO_TO: malzemeStokNoToList.length > 0 ? malzemeStokNoToList.toString() : '0',
        }

        setLoading(true);
        axios.get(`GetModelMuadilSuperAra/${data.USER_ID}/${data.MALZEME_STOK_NO_FROM_INPUT}/${data.MALZEME_STOK_NO_TO}/${data.BASLANGICTARIHI}/${data.BITISTARIHI}`).then((response) => {
            setGeneralData(response.data);
            setLoading(false);
        })
        setLoading(false);
    }

    function ModelMalzemeMuadilEkle() {
        if (malzemeStokNoFrom.length <= 0 || malzemeStokNoTo.length <= 0) {
            setresponseMessage('Lütfen kutucukları boş bırakmayınız!...')
            setUyariTip('error')
            setUyari(true)
            return
        }

        const data = {
            MalzemeStokNoFrom: malzemeStokNoFrom.toString(),
            MalzemeStokNoTo: malzemeStokNoTo.toString()
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('/ModelMalzemeMuadilEkle', data, config).then(response => {
            if (response.data.ErrorCode === '1000') {
                setresponseMessage(response.data.ErrorDescription)
                setUyariTip("error");
                setUyari(true);
            } else {
                setresponseMessage(response.data.ErrorDescription)
                setUyariTip("success");
                setUyari(true);
            }

            setMuadilModelEklePopUp(false);
            setMalzemeStokNoFrom([]);
            setMalzemeStokNoTo([]);

            if (selectedKullanici.length > 0) {
                var kullanicilarList = [];
                selectedKullanici.map((i) => {
                    kullanicilarList.push(i.USER_ID)
                })
                var malzemeStokNoToList = [];
                selectedMalzemeStokNoTo.map((i) => {
                    malzemeStokNoToList.push(i.MALZEME_STOK_NO_TO);
                })
                const data = {
                    BASLANGICTARIHI: formattedBaslangicDate,
                    BITISTARIHI: formattedBitisDate,
                    USER_ID: kullanicilarList.toString(),
                    MALZEME_STOK_NO_FROM_INPUT: malzemeStokNoFromInput.length > 0 ? malzemeStokNoFromInput : '0',
                    MALZEME_STOK_NO_TO: malzemeStokNoToList.length > 0 ? malzemeStokNoToList.toString() : '0',
                }
                axios.get(`GetModelMuadilSuperAra/${data.USER_ID}/${data.MALZEME_STOK_NO_FROM_INPUT}/${data.MALZEME_STOK_NO_TO}/${data.BASLANGICTARIHI}/${data.BITISTARIHI}`).then((response) => {
                    setGeneralData(response.data);
                })
            }

        });
    }

    function ModelMalzemeMuadilSil() {
        if (selectedRows.length <= 0) {
            setresponseMessage('Lütfen önce silmek istediğiniz satırları seçiniz!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        var seciliSatirlarList = [];

        selectedRows.map((i) => {
            seciliSatirlarList.push(i);
        })

        var seciliKullanicilarList = [];
        selectedKullanici.map((i) => {
            seciliKullanicilarList.push(i.USER_ID);
        })

        const data = {
            SeciliSatirlar: seciliSatirlarList.toString(),
            BASLANGICTARIHI: formattedBaslangicDate,
            BITISTARIHI: formattedBitisDate
        }

        confirmAlert({
            message: 'Seçili Satırları Silmek İstediğinize Emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        const config = {
                            headers: { 'Content-Type': 'application/json' }
                        }
                        axios.post('/ModelMalzemeMuadilSil', data, config).then(response => {
                            if (response.data.ErrorCode === '1000') {
                                setresponseMessage(response.data.ErrorDescription);
                                setUyariTip("error");
                                setUyari(true);
                            } else {
                                setresponseMessage(response.data.ErrorDescription);
                                setUyariTip("success");
                                setUyari(true);

                                GeneralDataFiltreleAra();
                                setSelectedRows([]);
                            }
                        });
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { return }
                }
            ]
        });


    }

    function handleExcelScreenClick(buttonType) {
        setExcelYukleSecimPopUp(false);

        if (buttonType === 1) {
            setExcelYukleSilPopUp(true);
        }
        if (buttonType === 2) {
            setExcelKaynakModelliYukleSilPopUp(true);
        }

    }

    const columns = [
        { field: 'ÜstMuadil', headerName: 'Üst Muadil(To)', width: 750 },
    ]
    const hedefVeKaynakliColumns = [
        { field: 'EOLMalzeme', headerName: 'EOL Malzeme(From)', width: 500 },
        { field: 'ÜstMuadil', headerName: 'Üst Muadil(To)', width: 500 },
    ]

    const FromColumns = [
        { field: 'MALZEME_STOK_NO_FROM', headerName: 'EOL Malzeme(From)', width: 500 },
        { field: 'MALZEME_STOK_NO_TO', headerName: 'Üst Muadil(To)', width: 500 },
    ]

    const EXTENSIONS = ['xlsx', 'xls', 'csv']

    const getExtension = (file) => {
        const parts = file.name.split('.');
        const extension = parts[parts.length - 1];
        return EXTENSIONS.includes(extension);
    };

    const onFileChange = (e) => {
        const files = e.target.files;

        if (files.length) {
            const file = files[0];
            const reader = new FileReader();

            if (getExtension(file)) {
                reader.readAsBinaryString(file);
            }
            reader.onload = (event) => {
                const bstr = event.target.result;
                const workBook = XLSX.read(bstr, { type: 'binary' });
                const workSheetName = workBook.SheetNames[0];
                const workSheet = workBook.Sheets[workSheetName];
                const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 });
                const headers = fileData[0];

                const updatedHeaders = headers;

                const rows = fileData.slice(1).map((row, index) => {
                    const rowData = {};
                    updatedHeaders.forEach((header, index) => {
                        rowData[header] = row[headers.indexOf(header)];
                    });
                    rowData.id = index;
                    return rowData;
                });

                if (e.target.id === 'FileInput') {
                    setDataExcel(rows);
                    findTheDifference(rows);
                }
                else {
                    setHedefVeKaynakliDataExcel(rows);
                    uploadToDataGrid(rows);
                }

            };
        }
    };

    const findTheDifference = (data) => {
        const changedValues = data.map(i => ({
            malzemeStokNoTo: String(i.ÜstMuadil)
        }));
        setChangedData(changedValues);

        var dataList = [];
        changedValues.map((row) => {
            dataList.push(row.malzemeStokNoTo);
        })

        const malzemeData = {
            MalzemeStokNoTo: dataList.toString()
        }
        axios.get(`/GetModelMuadilStokFrom/${malzemeData.MalzemeStokNoTo}`).then((response) => {
            if (response.data.length > 0) {
                const dataWithId = response.data.map((item, index) => ({
                    ...item,
                    id: index + 1,
                }));
                setMalzemeMuadilGelenFromlarData(dataWithId);
            }
        })
    };

    const uploadToDataGrid = (data) => {
        const changedValues = data.map(i => ({
            malzemeStokNoFrom: String(i.EOLMalzeme),
            malzemeStokNoTo: String(i.ÜstMuadil)
        }));
        setChangedData(changedValues);
    };

    function excelDataEkle(buttonType) {
        if (buttonType === 1 ? dataExcel.length <= 0 : hedefVeKaynaklidataExcel.length <= 0) {
            setresponseMessage('Lütfen önce excel dosyasını seçiniz!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setLoading(true);
        var data = [];
        changedData.map(i => {
            try {
                buttonType === 1 ?
                    data.push(
                        {
                            MalzemeStokNoToTable: i.malzemeStokNoTo
                        }
                    )
                    :
                    data.push(
                        {
                            MalzemeStokNoFromTable: i.malzemeStokNoFrom,
                            MalzemeStokNoToTable: i.malzemeStokNoTo
                        }
                    )
            } catch (ex) {
                setLoading(false);
            }
        })

        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        if (buttonType === 1) {
            axios.post('/ModelMalzemeMuadilExcelInsert', data, config).then(response => {
                setChangedData([]);
                setDataExcel([]);
                setMalzemeMuadilGelenFromlarData([]);
                setExcelYukleSilPopUp(false);
                setLoading(false);
            });
        } else if (buttonType === 2) {
            axios.post('/HedefveKaynakMalzemeliExcelInsert', data, config).then(response => {
                setChangedData([]);
                setHedefVeKaynakliDataExcel([]);
                setExcelKaynakModelliYukleSilPopUp(false);
                if (response.data.ErrorCode === '0') {
                    setresponseMessage(response.data.ErrorDescription);
                    setUyariTip('success');
                    setUyari(true);
                } else {
                    setresponseMessage(response.data.ErrorDescription);
                    setUyariTip('error');
                    setUyari(true);
                }
                setLoading(false);
            });
        }


        setLoading(false);
    }

    function excelDataSil(buttonType) {
        if (buttonType === 1 ? dataExcel.length <= 0 : hedefVeKaynaklidataExcel.length <= 0) {
            setresponseMessage('Lütfen önce excel dosyasını seçiniz!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setLoading(true);
        var data = [];
        changedData.map(i => {
            try {
                buttonType === 1 ?
                    data.push(
                        {
                            MalzemeStokNoToTable: i.malzemeStokNoTo
                        }
                    )
                    :
                    data.push(
                        {
                            MalzemeStokNoFromTable: i.malzemeStokNoFrom,
                            MalzemeStokNoToTable: i.malzemeStokNoTo
                        }
                    )
            } catch (ex) {
                setLoading(false);
            }
        })

        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        if (buttonType === 1) {
            axios.post('/ModelMalzemeMuadilExcelDelete', data, config).then(response => {
                setChangedData([]);
                setDataExcel([]);
                setMalzemeMuadilGelenFromlarData([]);
                setExcelYukleSilPopUp(false);
                setLoading(false);
            });
        } else if (buttonType === 2) {
            axios.post('/HedefveKaynakMalzemeliExcelDelete', data, config).then(response => {
                setChangedData([]);
                setHedefVeKaynakliDataExcel([]);
                setExcelKaynakModelliYukleSilPopUp(false);
                setLoading(false);
            });
        }

        setLoading(false);
    }



    function ModelMalzemeMuadilSelectRows(id) {
        if (!selectedRows.includes(id)) {
            setSelectedRows((prevSelectedRows) => [...prevSelectedRows, id]);
        } else {
            setSelectedRows((prevSelectedRows) => prevSelectedRows.filter((rowId) => rowId !== id));
        }
    }

    const handleMasterCheckboxChange = () => {
        if (selectedRows.length === generalData.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(generalData.map(row => row.ID));
        }
    };

    const handleExportClick = (buttonType) => {
        var exportData = [];
        if (buttonType === 1) {
            generalData && generalData.map((item) => {
                exportData.push({
                    'Malzeme Stok No From': item.MALZEME_STOK_NO_FROM,
                    'Malzeme Stok No To(Super Muadil)': item.MALZEME_STOK_NO_TO,
                    'Sicil Numarası': item.SICILNO,
                    'Ad-Soyad': item.ADSOYAD,
                    'Kayıt Tarihi': moment(item.KAYIT_TARIHI).format('DD-MM-YYYY h:mm:ss'),
                })
            })
            ExcelFileCreator(exportData, `Üst Muadil Raporu`);
        }
        if (buttonType === 2) {
            malzemeMuadilGelenFromlarData && malzemeMuadilGelenFromlarData.map((item) => {
                exportData.push({
                    'Malzeme Stok No From': item.MALZEME_STOK_NO_FROM,
                    'Malzeme Stok No To(Super Muadil)': item.MALZEME_STOK_NO_TO,
                })
            })
            ExcelFileCreator(exportData, `Üst Muadile Bağlı Kaynak Malzemeler`);
        }

    };

    const exampleExcelClick = (buttonType) => {
        if (buttonType === 1) {
            let exportData = [];
            exportData.push({
                'ÜstMuadil': '',
            })
            ExcelFileCreator(exportData, `Üst Muadil(To) Örnek Excel`);
        }
        if (buttonType === 2) {
            let exportData = [];
            exportData.push({
                'EOLMalzeme': '',
                'ÜstMuadil': '',
            })
            ExcelFileCreator(exportData, `EOL Malzeme(From) - Üst Muadil(To) Örnek Excel`);
        }
    };


    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container className={classes.container1} maxWidth="xl">
                <Card>
                    <CardHeader title="Üst Muadil" />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={2} style={{ marginBottom: '0.1rem' }}>
                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="multiple-limit-tags"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedKullanici}
                                    options={kullanicilar}
                                    getOptionLabel={option => (option.ADSOYAD ? option.ADSOYAD : '')}
                                    onChange={(event, newValue) => {
                                        setSelectedKullanici(newValue);
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.ADSOYAD}
                                        </React.Fragment>
                                    )}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Kullanıcılar"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4}>
                                <TextField
                                    label="EOL Malzeme (From)"
                                    fullWidth
                                    size='small'
                                    variant="outlined"
                                    value={malzemeStokNoFromInput}
                                    onChange={(event) => { setMalzemeStokNoFromInput(event.target.value); }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="multiple-limit-tags"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedMalzemeStokNoTo}
                                    options={malzemeStokNoToAutoComplete}
                                    getOptionLabel={option => (option.MALZEME_STOK_NO_TO ? option.MALZEME_STOK_NO_TO : '')}
                                    onChange={(event, newValue) => {
                                        setSelectedMalzemeStokNoTo(newValue);
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.MALZEME_STOK_NO_TO}
                                        </React.Fragment>
                                    )}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Üst Muadil (To)"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} lg={3}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap['tr']}
                                    >
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label={'Talep başlangıç tarihi'}
                                            invalidDateMessage={'Hatalı Tarih Formatı'}
                                            format={'dd.MM.yyyy'}
                                            value={talepEdilmeBaslangicTarihi}
                                            variant="outlined"
                                            onChange={date => {
                                                setTalepEdilmeBaslangicTarihi(date);
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={12} sm={3} lg={3}>
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={localeMap['tr']}
                                    >
                                        <KeyboardDatePicker
                                            fullWidth
                                            size="small"
                                            color="primary"
                                            inputVariant="outlined"
                                            label={'Talep bitiş tarihi'}
                                            invalidDateMessage={'Hatalı Tarih Formatı'}
                                            format={'dd.MM.yyyy'}
                                            value={talepEdilmeBitisTarihi}
                                            variant="outlined"
                                            onChange={date => {
                                                setTalepEdilmeBitisTarihi(date);
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={6}>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => { GeneralDataFiltreleAra() }}
                                    >
                                        ARA
                                        <SearchIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            handleExportClick(1);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    >
                                        YAZDIR
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            setMuadilModelEklePopUp(true);
                                        }}
                                    >
                                        Üst Muadil Ekle
                                        <AddIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            setExcelYukleSecimPopUp(true);
                                        }}
                                    >
                                        Excelden Yükle/Sil
                                        <AddIcon style={{ marginLeft: '5px' }} /> {'/'} <DeleteIcon />
                                    </Button>
                                </Stack>
                            </Grid>
                            <Divider />
                            <Grid item xs={12} sm={12} lg={12}>
                                <TableContainer >
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead style={{ overflowWrap: 'break-word' }}>
                                            <TableRow>
                                                <TableCell align="left">Id</TableCell>
                                                <TableCell align="left">EOL Malzeme (From)</TableCell>
                                                <TableCell align="left">Üst Muadil (To)</TableCell>
                                                <TableCell align="left">Sicil Numarası</TableCell>
                                                <TableCell align="left">Ad-Soyad</TableCell>
                                                <TableCell align="left">Kayıt Tarihi</TableCell>
                                                <TableCell align="left">
                                                    <Tooltip
                                                        title='Tümünü Seç/Çıkar'
                                                    >
                                                        <Checkbox
                                                            name="masterCheckbox"
                                                            size='medium'
                                                            onChange={handleMasterCheckboxChange}
                                                            checked={selectedRows.length === generalData.length}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title="Seçili olanları Sil">
                                                        <IconButton size="medium" onClick={() => { ModelMalzemeMuadilSil(); }}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {generalData.length > 0 && generalData.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                                <TableRow
                                                    key={row.ID}
                                                >
                                                    <TableCell align="left">{row.ID}</TableCell>
                                                    <TableCell align="left">{row.MALZEME_STOK_NO_FROM}</TableCell>
                                                    <TableCell align="left">{row.MALZEME_STOK_NO_TO}</TableCell>
                                                    <TableCell align="left">{row.SICILNO}</TableCell>
                                                    <TableCell align="left">{row.ADSOYAD}</TableCell>
                                                    <TableCell align="left">{moment(row.KAYIT_TARIHI).format("DD-MM-YYYY HH:mm")}</TableCell>
                                                    <TableCell align="left" >
                                                        <Checkbox
                                                            name="checkedB"
                                                            size='medium'
                                                            checked={selectedRows.includes(row.ID) ? true : false}
                                                            onChange={(event) => { ModelMalzemeMuadilSelectRows(row.ID) }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="left" />
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {generalData.length > 0 &&
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 50]}
                                        component="div"
                                        count={generalData.length}
                                        rowsPerPage={rpg}
                                        page={pg}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Dialog
                        open={muadilModelEklePopUp}
                        fullWidth
                        maxWidth="sm"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Üst Muadil Ekle</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <TextField
                                        label={'EOL Malzeme (From)'}
                                        variant='outlined'
                                        fullWidth
                                        value={malzemeStokNoFrom}
                                        onChange={(event) => { setMalzemeStokNoFrom(event.target.value); }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <TextField
                                        label={'Üst Muadil (To)'}
                                        variant='outlined'
                                        fullWidth
                                        value={malzemeStokNoTo}
                                        onChange={(event) => { setMalzemeStokNoTo(event.target.value); }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                className={classes.action}
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    ModelMalzemeMuadilEkle();
                                }}
                            >
                                Ekle
                            </Button>
                            <IconButton
                                color="primary"
                                onClick={(event) => { setMuadilModelEklePopUp(false); setMalzemeStokNoFrom([]); setMalzemeStokNoTo([]); }}
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={excelYukleSecimPopUp}
                        fullWidth
                        maxWidth="md"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Excelden Yükle/Sil</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1} className={classes.root}>
                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                    <Card
                                        className={classes.rootCard}
                                    >
                                        <CardMedia
                                            className={classes.media}
                                            image={image}
                                            title="Üst Muadil Belirterek Yükleme İşlemi"
                                        />
                                        <CardContent className={classes.customCardContent}>
                                            <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: 'center' }}>
                                                Üst Muadil Belirterek Yükleme İşlemi
                                            </Typography>
                                            <Divider style={{ marginBottom: '0.4rem' }} />
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="secondary"
                                                        size='medium'
                                                        onClick={() => { handleExcelScreenClick(1); }}
                                                    >
                                                        Yükle
                                                        <UploadIcon style={{ marginLeft: '0.3rem' }} />
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="secondary"
                                                        size='medium'
                                                        onClick={() => { exampleExcelClick(1) }}
                                                    >
                                                        Örnek Excel
                                                        <DownloadIcon style={{ marginLeft: '0.3rem' }} />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                    <Card
                                        className={classes.rootCard}
                                    >
                                        <CardMedia
                                            className={classes.media}
                                            image={image}
                                            title="EOL Malzeme(From) - Üst Muadil(To) Yükleme İşlemi"
                                        />
                                        <CardContent className={classes.customCardContent}>
                                            <Typography gutterBottom variant="h5" component="h2" style={{ textAlign: 'center' }}>
                                                EOL Malzeme(From) - Üst Muadil(To) Yükleme İşlemi
                                            </Typography>
                                            <Divider variant='fullWidth' style={{ marginBottom: '0.4rem' }} />
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => { handleExcelScreenClick(2); }}
                                                    >
                                                        Yükle
                                                        <UploadIcon style={{ marginLeft: '0.3rem' }} />
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} xm={12} md={6} xl={6}>
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => { exampleExcelClick(2) }}
                                                    >
                                                        Örnek Excel
                                                        <DownloadIcon style={{ marginLeft: '0.3rem' }} />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={(event) => { setExcelYukleSecimPopUp(false); }}
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={excelYukleSilPopUp}
                        fullWidth
                        maxWidth="lg"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Excelden Yükle/Sil</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} lg={6} />
                                <Grid item xs={12} sm={2} lg={2}>
                                    <input
                                        id="FileInput"
                                        type='file'
                                        onChange={onFileChange}
                                        onClick={(event) => { event.target.value = null }}
                                        hidden
                                        accept=".xlsx, .xls, .xml"
                                    >
                                    </input>
                                    <label htmlFor="FileInput">
                                        <Button
                                            className={classes.action}
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            component="span"
                                        >
                                            {'Yükle'}
                                        </Button>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2} lg={2}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => { excelDataEkle(1); }}
                                    >
                                        Kaydet
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={2} lg={2}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => { excelDataSil(1); }}
                                    >
                                        Sil
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <DataGrid
                                        style={{ height: 400, width: "100%" }}
                                        rows={dataExcel}
                                        columns={columns}
                                        rowsPerPageOptions={[5, 10, 20, 100]}
                                    />
                                </Grid>
                                <Typography variant="h6" style={{ fontWeight: 'bold', color: 'red' }}>
                                    Hedef Malzemeye Bağlı Ekleme İşlemi Yapılacak Kaynak Malzemeler:
                                </Typography>
                                <Grid item xs={12} sm={10} lg={10} />
                                <Grid item xs={12} sm={2} lg={2}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => {
                                            handleExportClick(2);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    >
                                        YAZDIR
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <DataGrid
                                        style={{ height: 400, width: "100%" }}
                                        rows={malzemeMuadilGelenFromlarData}
                                        columns={FromColumns}
                                        rowsPerPageOptions={[5, 10, 20, 100]}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={(event) => { setExcelYukleSilPopUp(false); setDataExcel([]); setChangedData([]); setMalzemeMuadilGelenFromlarData([]); }}
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={excelKaynakModelliYukleSilPopUp}
                        fullWidth
                        maxWidth="lg"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Excelden Yükle/Sil</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} lg={6} />
                                <Grid item xs={12} sm={2} lg={2}>
                                    <input
                                        id="FileInput2"
                                        type='file'
                                        onChange={onFileChange}
                                        onClick={(event) => { event.target.value = null }}
                                        hidden
                                        accept=".xlsx, .xls, .xml"
                                    >
                                    </input>
                                    <label htmlFor="FileInput2">
                                        <Button
                                            className={classes.action}
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            component="span"
                                        >
                                            {'Yükle'}
                                        </Button>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2} lg={2}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => { excelDataEkle(2); }}
                                    >
                                        Kaydet
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={2} lg={2}>
                                    <Button
                                        className={classes.action}
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => { excelDataSil(2); }}
                                    >
                                        Sil
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <DataGrid
                                        style={{ height: 400, width: "100%" }}
                                        rows={hedefVeKaynaklidataExcel}
                                        columns={hedefVeKaynakliColumns}
                                        rowsPerPageOptions={[5, 10, 20, 100]}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={(event) => { setExcelKaynakModelliYukleSilPopUp(false); setHedefVeKaynakliDataExcel([]); setChangedData([]); }}
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page >
    );
}
export default MaterialEquivalentReport;